import React from 'react'

const About = () => {
  return (
    <div name='About' className=' bg-gradient-to-b from-gray-800 to-black'>
        <div className='w-11/12 h-screen flex flex-col justify-center text-white mx-auto'>
            <div className='text-4xl text-start font-bold my-12'>
                <p className=' inline border-b-2 border-gray-400'>About</p>
            </div>
            <p className=' font-semibold'>I am a highly motivated and results-oriented software engineer at TCS with one year of professional experience in SAP CPI and enterprise integration. I possess a strong foundation in the MERN stack (MongoDB, Express.js, React.js, and Node.js) and hands-on experience with LangChain for building AI-driven applications. I have strengthened my problem-solving skills by successfully tackling over 700 Data Structures and Algorithms problems.

Beyond my technical expertise, I am a proactive and enthusiastic professional with a proven ability to take ownership and deliver results. I have leveraged my leadership and organizational skills through professional projects and as a joint coordinator in Sphuran, the electrical engineering department fest. I thrive in collaborative environments and consistently embrace new challenges with dedication and focus.
</p>
            <br/>
            <p className=' font-semibold'>To showcase my skills and accomplishments, I have created this portfolio website that highlights my projects, experiences, and technical proficiency. I am eager to apply my knowledge and skills to real-world challenges and contribute to meaningful projects.</p>
        </div>
    </div>
  )
}

export default About